import React, {useEffect, useState} from "react";
import nd from '../../images/newsdetail.jpg';
import { getNewsDetail } from "../../service";
import {useParams} from "react-router-dom";
import { NewsDetailData } from "../types";
import logo from "../../images/logo.png";
import {newsTime} from "../../units";

interface newsProps{
    newsId:string
}

function NewsDetail() {

    const [detail,setDetail] = useState<NewsDetailData>()

    const params = useParams<newsProps>()

    // console.log(params.newsId)

    useEffect(() => {
        getNewsDetail({
            id:params.newsId
        }).then(res => {
            if(res.code === 1){
                setDetail(res.data)
            }
        })
    },[])

    return <div className="tele-detail">
        <div className="date">{ newsTime(detail) }</div>
        <h3>
            { detail?.newsTitle }
        </h3>
        <p className="owner">
            <img src={ logo } alt=""/>
            <span>荷兰国际管家学院</span>
        </p>
        <div className="detail">
            <div dangerouslySetInnerHTML={{ __html:detail ? detail.newsContent : '' }}/>
        </div>


    </div>
}

export default NewsDetail;
